import type { ReactElement } from 'react';

import { overdueNote } from '../presentation';
import type { TrainingSummary } from '../types';

/** Indicadores de lectura de la empresa activa (mockup 06): documentos con lectura
 *  asignada, cobertura ponderada por personas y lecturas pendientes. Mientras
 *  cargan, un guion en vez de un número inventado. */
export function TrainingKpis({
  summary,
  companyName,
}: {
  summary: TrainingSummary | undefined;
  companyName: string | null;
}): ReactElement {
  const dash = summary === undefined;
  const coverage = summary?.coveragePct ?? null;
  const overdue = summary?.overdue ?? 0;
  return (
    <div className="tiles cols-3 rise d1">
      <div className="tile">
        <div className="k">Documentos con capacitación</div>
        <div className="v" aria-busy={dash || undefined}>
          {dash ? '—' : summary.documents.toLocaleString('es-CR')}
        </div>
        <div className="d">{companyName ? `vigentes en ${companyName}` : 'vigentes'}</div>
      </div>
      <div className="tile ok">
        <div className="k">Cobertura</div>
        <div className="v" aria-busy={dash || undefined}>
          {coverage === null ? '—' : Math.round(coverage)}
          {coverage !== null && <small>%</small>}
        </div>
        <div className="d">del personal asignado</div>
      </div>
      <div className="tile warn">
        <div className="k">Pendientes</div>
        <div className="v" aria-busy={dash || undefined}>
          {dash ? '—' : summary.pending.toLocaleString('es-CR')}
        </div>
        <div className="d">{overdueNote(overdue)}</div>
      </div>
    </div>
  );
}
